import React, { useEffect, useState } from 'react'
import { Row, Col, DatePicker, Panel } from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'

export default function ExpenseCheckForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)

  useEffect(() => {
    setFormSchema(_schema)
  }, [_schema])

  return (
    <>
      <Panel>
        <Row style={{ marginTop: 10 }}>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema.voucherNumber.label} : </b>
            {formSchema.voucherNumber.value}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema.voucherDate.label} : </b>
            {formSchema.voucherDate.value}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema.checkNumber.label} : </b>
            {formSchema.checkNumber.value}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema.checkDate.label} : </b>
            {formSchema.checkDate.value}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>{formSchema.checkStatus.label} : </b>
            {formSchema.checkStatus.value}
          </Col>
        </Row>
      </Panel>

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {requiredFiled(
            formSchema.checkClearingDate.validators,
            formSchema.checkClearingDate.label
          )}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema.checkClearingDate.name]} />
          <Controller
            key={formSchema.checkClearingDate.name}
            name={formSchema.checkClearingDate.name}
            control={control}
            defaultValue={
              formSchema.checkClearingDate.value
                ? moment(formSchema.checkClearingDate.value, DATE_PICKER_FORMAT).toDate()
                : moment().startOf('day').toDate()
            }
            rules={isValidators(formSchema.checkClearingDate.validators)}
            render={(props) => {
              return (
                <DatePickerCustom 
                  {...props}
                />
                // <DatePicker
                //   format={DATE_PICKER_FORMAT}
                //   locale={LOCAL_DAY_TH}
                //   block
                //   oneTap
                //   value={props.value}
                //   onChange={(value) => {
                //     props.onChange(value)
                //   }}
                //   //disabledDate={(date) => moment(new Date()).isBefore(date, new Date())}
                // />
              )
            }}
          />
        </Col>
      </Row>
    </>
  )
}
